import React, {useEffect, useReducer, useRef, useState} from "react";
import { Form, Input, Modal, message } from "antd";
import { atom, useAtom } from "jotai";
import {postMessage, triggerEvent, useEventListener} from "@/common/event";
import { showLoad,hideLoad } from "@/common/loadServer";

import * as model from '@model'
import {t} from "i18next";
import {EVENT_REFRESH_RECENTS, EVENT_RENAME_PAGES, EVENT_UPDATE_NOTE} from "@/Const";
import {IconCloseBlack} from "@/Icon";
import clipboard from "clipboardy";
import {KEYS} from "../../@excalidraw/packages/excalidraw/keys";
import {isInPageTag} from "@/utils";

/** 笔记atom状态  */
export const NoteAtom = atom<TNote[]>([]);

/** 笔记服务 */
export const noteServer = {
  /** 操作时间 */
  time: 0,
  /** 笔记map操作对象 */
  noteMap: new Map(),
  /** 笔记触发变更 */
  dispatch(fn) {
    fn(noteServer.noteMap);
    triggerEvent("note-change", [...noteServer.noteMap.values()]);
  },
  /** 删除笔记 */
  deleteNote(id: string) {
    noteServer.dispatch((note) => {
      note.get(id).deleteTime = Date.now();
      note.get(id).isDeleted = true;
    });
    model.editNote(noteServer.noteMap.get(id))
  },
  /** 收藏笔记 */
  favitateNote(id: string) {
    noteServer.dispatch((note) => {
      note.get(id).isFavirated = !note.get(id).isFavirated;
      note.get(id).favirateTime = Date.now()
    });
    model.editNote(noteServer.noteMap.get(id))
    return noteServer.noteMap.get(id)
  },
  /** 永久删除笔记 */
  deleteFovever(id: string) {
    noteServer.dispatch((note) => {
      note.delete(id);
    });
    model.deleteNote(id)
  },
  /** 获取笔记 */
  get(id: string) {
    const data = noteServer.noteMap.get(id);
    return data;
  },
  /** 新建笔记 */
  add(data: TNote) {
    const id = crypto.randomUUID();
    const noteNew = {
      ...data,
      isDeleted: false,
      isFavirated: false,
      time: Date.now(),
      id
    }
    noteServer.dispatch((note) => {
      note.set(id, noteNew);
    });
    model.addImg(id, data.img)
    model.addDoc(id, data.doc)
    model.addNote(noteNew)
    return noteNew
  },
  /** 复制笔记 */
  copy(id: string, showTip = true) {
    const new_id = crypto.randomUUID();
    const item = noteServer.noteMap.get(id);
    const data = {
      ...item,
      doc: item.doc?.replace?.(/^(\s?\<h1\>)([^\<]+)(\<\/h1.+\>)$/, '$1$2 copy$3'),
      name: item.name + " copy",
      id: new_id,
      isDeleted: false,
      isFavirated: false
    }
    noteServer.dispatch((note) => {
      note.set(new_id, data);
    });
    showTip && noteServer.openTip("success", t("Has copyed"));
    model.addNote(data)
    model.addImg(new_id, data.img)
    model.addDoc(new_id, data.doc)
    return data
  },
  /** 恢复笔记 */
  restore(id: string) {
    noteServer.dispatch((note) => {
      const item = note.get(id);
      note.delete(id);
      note.set(id, {
        ...item,
        time: Date.now(),
        isDeleted: false,
      });
    });

    model.editNote(noteServer.noteMap.get(id))
  },
  /** 清空回收站 */
  clearTrash() {
    noteServer.dispatch((note) => {
      [...note.values()].forEach((item) => {
        if (item.isDeleted) {
          note.delete(item.id);
          model.deleteNote(item.id)
        }
      });
    });
  },
  /** 编辑笔记 */
  edit(data: TNote, changeTime = true) {
    const item = {
      ...data,
      time: changeTime ? Date.now() : data.time
    }
    noteServer.dispatch((note) => {
      note.set(data.id, item);
    });

    model.editNote(noteServer.noteMap.get(data.id))
    model.editDoc(item.id, item.doc,item.name)
    model.editImg(item.id, item.img)
    return item

  },
  /** 改名 */
  rename(data: any) {
    triggerEvent("note-change-name", data);
  },
  /** 提示 */
  openTip(type: string, content: string) {
    content = content.replaceAll("Create PDF Success",t("Create PDF"));
    content = content.replaceAll("Create PDF Success",t("Create PDF Success"))

    content = t(content)

    setTimeout(() => {
      triggerEvent("note-open-tip", {
        type,
        content,
      })
      hideLoad()
    }, 0)
  },
  initFlag: false,
  /** 初始化 */
  init() {
    model.getNoteList().then((r) => {
      // console.log("r: ", r);
      if (!r?.length) {
        // noteTable.add({
        //   id: "nodeTable",
        //   data: JSON.stringify([]),
        // });
      } else {
        noteServer.noteMap = new Map(
            r.reduce((t, item) => [...t, [item.id, item]], [])
        );
      }
      noteServer.dispatch(() => { });
    });
  },
  /** 上下文 */
  useNoteContext: () => {
    const [neteAtom, setNoteAtom] = useAtom(NoteAtom);
    // if (!noteServer.initFlag) {
    useEventListener("note-change", ({ detail }) => {
      detail.sort((a, b) => b.time - a.time);
      setNoteAtom(detail);
    });
    useEffect(() => {
      noteServer.init();
    }, []);
    // noteServer.initFlag = true
    // }

    return (
        <>
          <RenameNote />
          <OpenTip />
        </>
    );
  },
};

/** 改名弹窗 */
const RenameNote = () => {
  const [renameShow, setRenameShow] = useState(false);
  const [name, setName] = useState("");
  const [data, setData] = useState<any>();
  const inputRef = useRef();
  useEventListener("note-change-name", ({ detail }: { detail: any }) => {
    setName(detail.name);
    setData(detail);
    setRenameShow(true);
  });
  const onAfterOpenChange = ()=>{
    inputRef?.current?.focus();
  }
  if (!renameShow) return null;
  return (
      <Modal
          afterOpenChange={onAfterOpenChange}
          width={'468px'}
          footer={''}
          open={renameShow}
          centered={true}
          closeIcon={<IconCloseBlack/>}
          onOk={() => {
            if (name.trim() === "") {
              return noteServer.openTip("error", t("Please input name"));
            }
            setRenameShow(false);
            postMessage(EVENT_RENAME_PAGES,{id:data.id,name:name});
            postMessage(EVENT_REFRESH_RECENTS);
            //刷新画布上的....


            // const item = {
            //   ...data,
            //   name
            // }
            // delete item.searchName
            //
            // noteServer.dispatch((note) => {
            //   note.set(data.id, item);
            // });
            // model.editNote(noteServer.noteMap.get(data.id))
            // model.getDoc(data.id).then(r => {
            //   let newDoc = r.data.replace(/^(\s?\<h1\>)([^\<]+)(\<\/h1.+)$/, `$1${name}$3`)
            //   model.editDoc(data.id, newDoc)
            // })

          }}
          onCancel={() => {
            setRenameShow(false);
          }}
      >
        <div className={'flex-col'}>
          <span className={'dialog-title'}>{t("Rename")}</span>
          <div className='line' style={{margin: '12px -22px'}}></div>
          <Input variant={'borderless'} className={'input-border mt-10'} ref={inputRef} value={name}
                 onChange={(e) => setName(e.target.value)} onKeyDown={(event)=>{
                   if (event.key == KEYS.ENTER) {
                     if (name.trim() === "") {
                       return noteServer.openTip("error", t("Please input name"));
                     }
                     setRenameShow(false);
                     postMessage(EVENT_RENAME_PAGES,{id:data.id,name:name});
                   }
          }}/>
          <div className={'flex-center'} style={{marginTop: '20px'}}>
            <div className={'button-border-gray-style flex-center'} style={{minWidth: '164px', height: '38px'}} onClick={()=>{
              setRenameShow(false);
            }}>
              <span>{t('Cancel')}</span>
            </div>
            <div className='flex-center button-solid-style ml-10'
                 style={{minWidth: '164px', height: '38px', alignSelf: 'center'}}
                 onClick={() => {
                   //确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定确定
                   if (name.trim() === "") {
                     return noteServer.openTip("error", t("Please input name"));
                   }
                   setRenameShow(false);
                   postMessage(EVENT_RENAME_PAGES,{id:data.id,name:name});

                 }}>
              <span className='ml-6 font-family-medium'>{t("Save")}</span>
            </div>
          </div>
        </div>

      </Modal>
  );
};

/** 通用提示 */
const OpenTip = () => {
  const [messageApi, contextHolder] = message.useMessage();
  useEventListener("note-open-tip", ({detail}) => {
    messageApi.open(detail);
  });
  useEffect(() => {
    //@ts-ignore
    window.openTip = (type, content: string) => {
      messageApi.open({type, content});
    }
  }, [])
  return <> {contextHolder}</>;
};

/* 获取笔记名 */
export function getNoteName(): string {
  // const html = window.GEditor?.getHTML?.() as string;
  // if (/^\<h1/.test(html)) {
  //   return html.replace(/^\<h1\>([^\<]+)?\<\/h1.+\>(.+)?$/, '$1').replace(/<\/?h1>/g,'')
  // }
  // return ''
  return document.querySelector('#NOTE_TITLE_INPUT')?.value || '';
}

